import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import './ScheduleReportsCalendar.scss';
import classNames from 'classnames';
import {Input} from "reactstrap";
import oitsActionCreators from "../../store/oits/action-creators";
import trainingPhasesReportsActionCreators from "../../store/training-phases/action-creators/training-phase-reports";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators";
import DisplayUserPhoto from "../users/DisplayUserPhoto";
import ReactTooltip from 'react-tooltip';
import ftosActionCreators from '../../store/ftos/action-creators';
import departmentSettingsSelectors from '../../store/department-settings/selectors';
import usersActionCreators from "../../store/users/action-creators";
import Modal from '../../../shared/ui/Modal';
import DwCalendar from "../calendar/DwCalendar";
import calendarActionCreators from '../../store/calendar/action-creators';
import DisplayBoolean from "../../../shared/forms/DisplayBoolean";
import PhaseSummary from "../oits/PhaseSummary";
import {ApiGetRaw} from "../../../shared/services/api-service";
import reportModel from '../../models/report';
import PbleField from "./dynamic-form/PbleField";
import LoadingButton from "../../../shared/ui/LoadingButton";

const weekdays = moment.weekdays();
const currentMonth = moment().month();
let keyEventListener = null

class ScheduleReportsCalendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDates: {},
      selectedMonth: moment().month(),
      year: moment().year(),
      selectedReportType: 'dor',
      selectedOitGuid: '',
      selectedCalendarOitGuid: '',
      selectedPhaseGuid: '',
      selectedFto: '',
      hour: null,
      minutes: null,
      currentDate: moment(),
      selectedDatesOfWeek: {},
      currentOpenedDatePopup: null,
      isLoading: false,
      showSubmitterModal: false,
      showCalendarModal: false,
      showOitCalendarModal: false,
      selectedSubmitter: '',
      selectedType: null,
      selectedDay: '',
      selectedFtoGuid: '',
      showEventDetailsModal: false,
      selectedEvent: null,
      phaseSummary: null,
      calendarStartDate: moment().startOf('month').startOf('week').format('YYYY-MM-DD'),
      calendarEndDate: moment().endOf('month').endOf('week').format('YYYY-MM-DD'),
      oitCalendarStartDate: moment().startOf('month').startOf('week').format('YYYY-MM-DD'),
      oitCalendarEndDate: moment().endOf('month').endOf('week').format('YYYY-MM-DD'),
      createdReport: null,
      showPbleFormDialog: false,
      pbleField: null,
      pbleKey: null,
      formResponses: {}
    };

    this.props.fetchUsers();
  }

  get canSelectNextMonth() {
    return this.selectedMonth === currentMonth;
  }

  get eventsWithDate() {
    return this.props.events.reduce(function (acc, event) {
      return [
        ...acc,
        {
          ...event,
          start: new Date(event.start),
          end: new Date(event.end)
        }
      ];

    }, []);
  }

  get getFtos() {
    return this.props.users && this.props.users.filter(u => u.roles.map(user => user.scope).includes('fto'));
  }

  selectDate(date) {
    if (!this.hasScheduledReport(date) && !this.hasCreatedReport(date) && !!date && this.isDateAvailable(date)) {
      this.setState({
        selectedDates: {
          ...this.state.selectedDates,
          [date]: !this.state.selectedDates[date]
        }
      })
    }
  }

  selectDateOfWeek(date, hour) {

    this.setState({
      selectedDatesOfWeek: {
        ...this.state.selectedDatesOfWeek,
        [this.getIsoDate(date, hour)]: !this.isDateSelected(date, hour)
      }
    })
  }

  get selectedMonth() {
    return this.state.currentDate.month();
  }

  isDateSelected(date, hour) {
    return this.state.selectedDatesOfWeek[this.getIsoDate(date, hour)]
  }

  get datesInMonthValues() {
    const firstDateOfMonth = moment([this.state.year, this.selectedMonth, 1]);
    // Padding days before the day of the first date in the month; account for locales starting week
    //   on Monday instead of Sunday
    const dayOfFirstDayInMonth = firstDateOfMonth.day();
    const paddingDays = (dayOfFirstDayInMonth < 0) ? (7 + dayOfFirstDayInMonth) : dayOfFirstDayInMonth;
    return Array.from({length: (firstDateOfMonth.daysInMonth() + paddingDays)}, (value, index) => {
      const date = ((index + 1) - paddingDays);
      return (index < paddingDays) ? null : date;
    });

  }

  get monthName() {
    return moment([this.state.year, this.selectedMonth, 1]).format('MMMM');
  }

  setReportType(type) {
    this.setState({
      selectedReportType: type
    })
  }

  setPhase(trainingPhaseGuid) {
    this.setState({
      selectedPhaseGuid: trainingPhaseGuid
    })

    ApiGetRaw(`/api/v1/training-phases/${trainingPhaseGuid}/count-reports`)
      .then((res) => {
        this.setState({
          phaseSummary: res
        })
      })

    this.props.fetchReports(trainingPhaseGuid);
  }

  setFto(ftoId) {
    this.setState({
      selectedFto: ftoId
    })
  }

  get scheduledReportsMap() {
    return this.props.reports
      ? this.props.reports.filter(r => {
        return r.getHasScheduledAction()
      }).reduce((acc, r) => {
        let date = `${moment(r.schedule.observationDate).format('YYYY-MM-DD')}`;
        return {
          ...acc,
          [date]: [...(acc[date] || []), {type: r.type, guid: r.guid, isCompleted: r.status !== 'scheduled'}]
        }
      }, {}) : {}
  }

  onTimeSelectorChanged(date) {
    let d = moment(date);

    this.setState({
      hour: d.hours(),
      minutes: d.minutes()
    });

  }

  get allowedFormTypes() {
    if (this.selectedOit) {
      let signFlow = this.selectedOit.trainingTracker.trainingProgram.signFlow

      let types = Object.keys(signFlow)
        .filter(key => {
          return signFlow[key].submit
            && !['cont', 'rrt'].includes(key)
            && (
              signFlow[key].submit.roles.includes('fto')
              || signFlow[key].submit.roles.includes('ftoc')
              || signFlow[key].submit.roles.includes('sup')
              || signFlow[key].submit.roles.includes('oit')
            )

        });
      return types;
    } else {
      return []
    }
  }

  componentDidMount() {
    this.props.loadOitsContainer();
    this.props.fetchFtos();

    keyEventListener = this.keyEventListener.bind(this)
    document.addEventListener('keyup', keyEventListener, false)
  }

  keyEventListener(e) {
    if (e.which === 39) {
      this.setState({
        currentDate: this.state.currentDate.clone().add(1, 'days')
      })
    } else if (e.which === 40) {
      this.setState({
        currentDate: this.state.currentDate.clone().add(1, 'weeks')
      })
    } else if (e.which === 38) {
      if (
        this.state.currentDate.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
        || this.state.currentDate.valueOf() < moment().valueOf()) {
        return false;
      }
      this.setState({
        currentDate: this.state.currentDate.clone().subtract(1, 'weeks')
      })
    } else if (e.which === 37) {
      if (this.state.currentDate.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
        return false;
      }
      this.setState({
        currentDate: this.state.currentDate.clone().subtract(1, 'days')
      })
    } else if (e.which === 68) {
      this.scheduleSingleReport('dor')
    } else if (e.which === 87) {
      this.scheduleSingleReport('wor')
    } else if (e.which === 69) {
      this.scheduleSingleReport('eop')
    } else if (e.which === 8) {
      let scheduledReports = this.scheduledReportsMap[this.getIsoDate(this.state.currentDate.date())];
      if (scheduledReports && scheduledReports.length) {
        scheduledReports = [...scheduledReports];
        scheduledReports.reverse();
        let report = scheduledReports.find(r => !r.isCompleted);
        report && this.props.deleteScheduledReport(report.guid)
      }
    }

    setTimeout(() => {
      this.setState({
        year: this.state.currentDate.year()
      })
    }, 1)
  }

  hasCreatedReport(day) {
    return this.props.reports
      && this.props.reports.find(r => {
        if (r.getHasScheduledAction() && r.status !== 'scheduled') {
          let observationDate = moment(r.schedule.observationDate);
          return observationDate.date() === day && observationDate.month() === this.state.selectedMonth;
        } else {
          return false;
        }
      })
  }

  getIsoDate(day) {
    if (!day) {
      return 'no-date'
    }
    let date = this.state.currentDate.clone();
    date.date(day);
    return date.format('YYYY-MM-DD');
  }

  selectNextMonth() {
    this.setState({
      currentDate: this.state.currentDate.clone().add(1, 'months')
    })
    setTimeout(() => {
      this.setState({
        year: this.state.currentDate.year()
      })
    }, 1)
  }

  scheduleReports() {

    let reports = [];

    Object.keys(this.state.selectedDatesOfWeek).map((date) => {
      if (this.state.selectedDatesOfWeek[date]) {
        reports.push({
          type: this.state.selectedReportType,
          schedule: {
            observationDate: date,
            submittedBy: date,
          }
        })
      }
    });

    this.props.createScheduledReports({
      reports: reports,
      trainingPhaseGuid: this.state.selectedPhaseGuid,
    }).then(() => {
      this.setState({
        selectedDates: {},
        selectedDatesOfWeek: {}
      })
    });

  }

  selectPrevMonth() {
    this.setState({
      currentDate: this.state.currentDate.clone().subtract(1, 'months')
    })
    setTimeout(() => {
      console.log(this.state.currentDate.year())
      this.setState({
        year: this.state.currentDate.year()
      })
    }, 1)
  }


  goNextWeek() {
    this.setState({
      currentDate: this.state.currentDate.clone().add(7, 'd')
    })
  }

  goPrevWeek() {
    this.setState({
      currentDate: this.state.currentDate.clone().subtract(7, 'd')
    })
  }

  setSelectedOit(oitGuid, event) {
    let selected = this.props.oits.find(o => o.guid === oitGuid);
    let openedPhase = selected.trainingPhases.find(tp => tp.status === 'opened') || selected.trainingPhases.find(tp => tp.sequence === 0);

    this.setState({
      selectedOitGuid: oitGuid,
      selectedPhaseGuid: openedPhase.trainingPhaseGuid,
      selectedFto: ''
    });

    this.props.fetchReports(openedPhase.trainingPhaseGuid);

    ApiGetRaw(`/api/v1/training-phases/${openedPhase.trainingPhaseGuid}/count-reports`)
      .then((res) => {
        this.setState({
          phaseSummary: res
        })
      })

    event.target.blur();
  }

  setSelectedFto(oitGuid, event) {
    this.setState({
      selectedFtoGuid: oitGuid
    });

    this.props.fetchEventsForDateRange(oitGuid, this.state.calendarStartDate, this.state.calendarEndDate);
    event.target.blur();
  }

  get selectedFto() {
    const selectedOit = this.props.oits
      && this.props.oits.find(o => o.guid === this.state.selectedOitGuid);

    if (selectedOit && this.state.selectedFto === '') {
      const phase = selectedOit.trainingPhases.find((phase) => phase.trainingPhaseGuid === this.state.selectedPhaseGuid);
      if (phase.fto) {
        return phase.fto.ftoGuid;
      }
    }

    return this.state.selectedFto;
  }

  hasScheduledReport(day) {
    return this.props.reports
      && this.props.reports.find(r => {
        if (r.getHasScheduledAction() && r.status === 'scheduled') {
          let observationDate = moment(r.schedule.observationDate);
          return observationDate.date() === day && observationDate.month() === this.selectedMonth;

        } else {
          return false;
        }
      })
  }

  scheduleSingleReportFromPopup(e, type, day) {
    e.stopPropagation();

    const signFlowRoles = this.selectedOit.trainingTracker.trainingProgram.signFlow[type];
    let selectedSubmitter = null;
    if (signFlowRoles && !signFlowRoles.submit.roles.includes('fto') && !signFlowRoles.submit.roles.includes('oit') && !this.state.selectedSubmitter) {
      this.setState({
        showSubmitterModal: true,
        selectedType: type,
        selectedDay: day
      })

      return
    } else if (signFlowRoles && signFlowRoles.submit.roles.includes('fto') && !signFlowRoles.submit.roles.includes('oit') && !this.state.selectedSubmitter && !this.selectedFto) {
      this.setState({
        showSubmitterModal: true,
        selectedType: type,
        selectedDay: day
      })

      return
    } else if (signFlowRoles && signFlowRoles.submit.roles.includes('oit')) {
      console.log('')
      this.setState({
        selectedSubmitter: this.state.selectedOitGuid
      })

      selectedSubmitter = this.state.selectedOitGuid
    } else if (signFlowRoles && signFlowRoles.submit.roles.includes('fto') && this.selectedFto && !this.props.canChangeFtoInSchedule) {
      selectedSubmitter = this.selectedFto
    }

    this.scheduleSingleReport(type, day, selectedSubmitter);
    this.setState({
      currentOpenedDatePopup: null,
      selectedType: null,
      selectedDay: '',
      selectedSubmitter: ''
    })
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', keyEventListener, false)
  }

  get selectedOit() {
    return this.props.oits
      && this.props.oits.find(o => o.guid === this.state.selectedOitGuid);
  }

  setSelectedCalendarOit(oitGuid, event) {
    this.setState({
      selectedCalendarOitGuid: oitGuid
    });

    this.props.fetchEventsForDateRange(oitGuid, this.state.calendarStartDate, this.state.calendarEndDate);
    event.target.blur();
  }

  scheduleSingleReport(type, day, selectedSubmitter) {
    if (this.state.isLoading) {
      return;
    }

    let date = this.state.currentDate.clone();
    date.date(day || date.date());

    this.setState({
      isLoading: true
    });

    let reportObj = {
      reports: [{
        type,
        schedule: {
          observationDate: date,
          submittedBy: date,
        }
      }],
      trainingPhaseGuid: this.state.selectedPhaseGuid,
    }

    if (this.selectedFto !== '' && this.props.canChangeFtoInSchedule) {
      reportObj.authorGuid = this.selectedFto;
    }

    if (this.state.selectedSubmitter) {
      reportObj.authorGuid = this.state.selectedSubmitter;
    }

    if (selectedSubmitter) {
      reportObj.authorGuid = selectedSubmitter;
    }

    this.props.createScheduledReports(reportObj)
      .then((report) => {
        console.log('SCHEDULED REPORT', report)
        this.checkIfReportHasPble(reportModel(report.data[0]))
        this.setState({
          selectedDates: {},
          selectedDatesOfWeek: {},
          isLoading: false,
          selectedSubmitter: ''
        })
      }).catch(() => {
      this.setState({
        isLoading: false
      })
    })
  }

  checkIfReportHasPble(report) {
    let pbleField = report.layout.find(l => l.schema === 'pble');
    if(!!pbleField && !pbleField.allowOitToChoosePble) {
      this.setState({
        createdReport: report,
        showPbleFormDialog: true,
        pbleField: pbleField,
        pbleKey: report.layout.findIndex(l => l.schema === 'pble')
      })
    }
  }

  handlePbleInput(key, valueObject) {
    this.setState({
      formResponses: {
        ...this.state.formResponses,
        [key]: valueObject,
      },
    })
  }

  parseResponsesFromState(stateResponses) {
    const responses = Object.keys(stateResponses).reduce((accumulator, key) => {
      const valueObject = { ...stateResponses[key] };
      // Remove params used for validation in this component
      delete valueObject.isValid;
      delete valueObject.touched;
      accumulator.push({
        ...valueObject,
        sequence: key,
      });
      return accumulator;
    }, []);
    return responses;
  }
  submitPbleForm() {
    this.setState({
      isFormLoading: true
    })
    const formData = {
      responses: this.parseResponsesFromState({
        ...this.state.formResponses,
      }),
      signedAt: null,
      guid: this.state.createdReport.guid,
      shift: null
    };

    this.props.updateReportResponses(formData, true)
      .then(() => {
        this.setState({
          isFormLoading: false,
          createdReport: null,
          showPbleFormDialog: false,
          pbleField: null,
          pbleKey: null
        })
      })
      .catch(() => {
        this.setState({

          isFormLoading: false
        })
      })
  }

  get oitsInProgress() {
    return this.props.oits
      && this.props.oits.filter(o =>
        //o.trainingPhases.find(tp => tp.status === 'opened'))
        o.trainingTracker && (o.trainingTracker.status === 'opened' ||  o.trainingTracker.status === 'paused'))
  }

  selectedOitObject(selectedUuid) {
    return this.oitsInProgress
      && this.oitsInProgress.find(tp => tp.guid === selectedUuid)
  }

  isDateAvailable(day) {
    if (currentMonth !== this.selectedMonth) {
      return true;
    } else {
      return moment().date() <= day;
    }
  }

  isSelected(day) {
    return this.state.currentDate.date() === day;
  }

  get canSelectPrevMonth() {
    return !this.canSelectNextMonth;
  }

  isDatePopupOpened(day) {
    return this.state.currentOpenedDatePopup
      && this.state.currentOpenedDatePopup.date() === day
      && this.state.currentOpenedDatePopup.month() === this.state.currentDate.month()
  }

  openDatePopup(day) {
    let date = this.state.currentDate.clone();
    date.date(day);

    this.setState({
      currentOpenedDatePopup: date
    })
  }

  get hoursInDay() {
    return new Array(24).fill().map((d, i) => i);
  }

  get daysOfWeek() {
    let startOfWeek = this.state.currentDate.clone().startOf('isoWeek');
    let endOfWeek = this.state.currentDate.clone().endOf('isoWeek');

    let days = [];
    let day = startOfWeek;

    while (day <= endOfWeek) {
      days.push(day);
      day = day.clone().add(1, 'd');
    }

    return days;
  }

  closeDatePopup(e) {
    e.stopPropagation();
    this.setState({
      currentOpenedDatePopup: null
    })
  }

  formFullName(type) {
    try {
      return this.props.forms.find(form => form.type === type).name;
    } catch (e) {
      return 'Full form name not found'
    }
  }

  closeSubmittersModal() {
    this.setState({
      showSubmitterModal: false,
      selectedSubmitter: ''
    })
  }

  closeCalendarModal() {
    this.setState({
      showCalendarModal: false,
    })
  }

  closeOitCalendarModal() {
    this.setState({
      showOitCalendarModal: false,
    })
  }

  onSubmitterChange(value) {
    this.setState({
      selectedSubmitter: value
    })
  }

  assignSubmitter() {
    this.scheduleSingleReport(this.state.selectedType, this.state.selectedDay);

    this.setState({
      currentOpenedDatePopup: null,
      showSubmitterModal: false,
      selectedDay: '',
      selectedType: null
    })
  }

  filterOfficersForSignFlow() {
    let users = [];

    if (this.selectedOit && this.state.selectedType) {
      const signFlow = this.selectedOit.trainingTracker.trainingProgram.signFlow[this.state.selectedType].submit;

      if (signFlow) {
        users = this.props.users && this.props.users.filter(u => signFlow.roles.some(v => u.roles.map(user => user.scope).includes(v)))
      }
    }

    return users;
  }

  openCalendarModal() {
    const startDate = moment(this.state.currentDate).startOf('month').startOf('week').format('YYYY-MM-DD');
    const endDate = moment(this.state.currentDate).endOf('month').endOf('week').format('YYYY-MM-DD');

    this.setState({
      showCalendarModal: true,
      calendarStartDate: startDate,
      calendarEndDate: endDate
    })

    if (!this.state.selectedFtoGuid) {
      this.setState({
        selectedFtoGuid: this.selectedFto
      }, () => {
        if (this.state.selectedFtoGuid) {
          this.props.fetchEventsForDateRange(this.state.selectedFtoGuid, startDate, endDate);
        }
      })
    }

    if (this.state.selectedFtoGuid) {
      this.props.fetchEventsForDateRange(this.state.selectedFtoGuid, startDate, endDate);
    }

  }

  openOitCalendarModal() {
    const startDate = moment(this.state.currentDate).startOf('month').startOf('week').format('YYYY-MM-DD');
    const endDate = moment(this.state.currentDate).endOf('month').endOf('week').format('YYYY-MM-DD');

    this.setState({
      showOitCalendarModal: true,
      oitCalendarStartDate: startDate,
      oitCalendarEndDate: endDate
    })

    if (!this.state.selectedCalendarOitGuid) {
      this.setState({
        selectedCalendarOitGuid: this.state.selectedOitGuid
      }, () => {
        if (this.state.selectedCalendarOitGuid) {
          this.props.fetchEventsForDateRange(this.state.selectedCalendarOitGuid, startDate, endDate);
        }
      })
    }

    if (this.state.selectedCalendarOitGuid) {
      this.props.fetchEventsForDateRange(this.state.selectedCalendarOitGuid, startDate, endDate);
    }

  }

  onUpdateEventsForDateRange(startDate, endDate) {
    this.setState({
      calendarStartDate: startDate,
      calendarEndDate: endDate
    })

    this.props.fetchEventsForDateRange(this.state.selectedFtoGuid, startDate, endDate);
  }

  onUpdateOitEventsForDateRange(startDate, endDate) {
    this.setState({
      calendarStartDate: startDate,
      calendarEndDate: endDate
    })

    this.props.fetchEventsForDateRange(this.state.selectedCalendarOitGuid, startDate, endDate);
  }

  onShowEventDetailsModal(event) {
    this.setState({
      showEventDetailsModal: true,
      selectedEvent: event
    })
  }

  closeEventDetailsModal() {
    this.setState({
      showEventDetailsModal: false
    })
  }

  getTypeLabel(type) {
    const types = {
      on: 'Days on',
      off: 'Days off',
      court: 'Court Time',
      vacation: 'Vacation Time',
      shift: 'Start and End time of shift'
    }

    return types[type];
  }

  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">ASSIGN WEEKLY SCHEDULES</h4>
        </div>
        <div className="app-content schedule-reports-calendar">
          <div className="schedule-form form column">
            {this.selectedOit && this.selectedOit.photo &&
            <div className="photo-container">
              <DisplayUserPhoto
                user={this.selectedOit}
              />
            </div>
            }
            <div className="form-group">
              <Input
                name="type"
                onChange={event =>
                  this.setSelectedOit(event.target.value, event)
                }
                type="select"
                value={this.state.selectedOitGuid}
              >
                <option defaultValue>Select {this.props.oitShortLabel}</option>
                {this.oitsInProgress && this.oitsInProgress.map(oit => (
                  <option key={oit.guid} value={oit.guid}>{oit.getFullName()}</option>
                ))}
              </Input>
            </div>

            {this.selectedOit && (
              <div className="form-group">
                <Input
                  name="type"
                  onChange={event =>
                    this.setPhase(event.target.value)
                  }
                  type="select"
                  value={this.state.selectedPhaseGuid}
                >
                  {this.selectedOit.trainingPhases.map(tp => (
                    <option value={tp.trainingPhaseGuid}>{tp.header}</option>
                  ))}
                </Input>
              </div>
            )}

            {this.props.canChangeFtoInSchedule && this.props.activeFtos && this.selectedOit && (
              <div className="form-group">
                <Input
                  name="type"
                  onChange={event =>
                    this.setFto(event.target.value)
                  }
                  type="select"
                  value={this.selectedFto}
                >
                  <option value=''>Select {this.props.ftoShortLabel}</option>
                  {this.props.activeFtos.map(fto => (
                    <option value={fto.guid}>{fto.getFullName()}</option>
                  ))}
                </Input>
              </div>
            )}

            {/*<div className="save" onClick={() => this.scheduleReports()}>*/}
            {/*<button className="button small primary">*/}
            {/*<i className="fa fa-save"/>*/}
            {/*<span>Save</span>*/}
            {/*</button>*/}
            {/*</div>*/}
          </div>

          <div className="calendar-btn">
            <button className="button small primary" onClick={() => this.openCalendarModal()}>
              <span>{this.props.ftoShortLabel} personal calendar</span>
            </button>
            <button className="button small primary ml-1" onClick={() => this.openOitCalendarModal()}>
              <span>{this.props.oitShortLabel} personal calendar</span>
            </button>
          </div>

          {this.state.selectedOitGuid && (
            <div className="calendar-container">
              <div className="calendar">
                <div className="month">
                  <div
                    onClick={() => this.selectPrevMonth()}
                    className={classNames('next-prev', {disabled: !this.canSelectPrevMonth})}>
                    <i className="fa fa-chevron-left"/>
                  </div>
                  <div>{this.monthName} {this.state.year}</div>
                  <div
                    onClick={() => this.selectNextMonth()}
                    className={classNames('next-prev', {disabled: !this.canSelectNextMonth})}>
                    <i className="fa fa-chevron-right"/>
                  </div>
                </div>
                <div className="weekdays">
                  {weekdays.map(day => (
                    <div className="weekday" key={day}>{day}</div>
                  ))}
                </div>
                <div className="days">
                  {this.datesInMonthValues.map((day, index) => (
                    <div key={index} className={classNames('day', {
                      'has-day': !!day && this.isDateAvailable(day),
                      'selected': this.state.selectedDates[day],
                      // 'has-report': this.hasScheduledReport(day) || this.hasCreatedReport(day),
                      'is-selected': this.isSelected(day)
                    })}
                         onClick={() => this.openDatePopup(day)}>
                      <div className="day-container">
                        <span className="day-label">{day}</span>
                        {this.scheduledReportsMap[this.getIsoDate(day)]
                          && this.scheduledReportsMap[this.getIsoDate(day)].map(r =>
                              <span key={r.guid}
                                    className="scheduled">
                          <span style={{textTransform: 'uppercase'}} data-tip={this.formFullName(r.type)}>
                            {r.type}
                            <ReactTooltip
                              place="top"
                              className="customTheme form-name"
                              effect="solid"
                            />
                          </span>
                                {r.isCompleted
                                  ? <i className="fa fa-check"/>
                                  : <i className="fa fa-trash" onClick={(e) => {
                                    e.stopPropagation();
                                    this.props.deleteScheduledReport(r.guid)
                                  }}/>}
                          </span>
                          )}
                        {this.isDatePopupOpened(day) && (
                          <div className="report-options">
                            <div onClick={(e) => this.closeDatePopup(e)}><i className="fa fa-close"/></div>
                            {this.allowedFormTypes.map(key => (
                              <div onClick={(e) => this.scheduleSingleReportFromPopup(e, key, day)} data-tip={this.formFullName(key)}>
                                {key}
                                <ReactTooltip
                                  place="top"
                                  className="customTheme form-name"
                                  effect="solid"
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {this.state.phaseSummary && <PhaseSummary
                compact={true}
                oit={this.selectedOit}
                phaseSummary={this.state.phaseSummary}
                phase={this.selectedOit.trainingPhases.find((phase) => phase.trainingPhaseGuid === this.state.selectedPhaseGuid)}
              />}
            </div>
          )}
        </div>

        <Modal
          title="Choose Submitter"
          isOpen={this.state.showSubmitterModal}
          onClose={(e) => this.closeSubmittersModal(e)}
          size="sm"
        >
          <div className="submitters-options">
            <select
              value={this.state.selectedSubmitter}
              onChange={(e) => this.onSubmitterChange(e.target.value)} >
              {!this.state.selectedSubmitter && <option value="" disabled>Select Submitter</option>}
              {this.filterOfficersForSignFlow() && this.filterOfficersForSignFlow().map((oit) => (
                <option
                  key={oit.guid}
                  value={oit.guid}>
                  {oit.getFullName()}
                </option>
              ))}
            </select>

            <div className="btn-container">
              <button
                className="button small primary"
                onClick={() => this.assignSubmitter()}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          title={this.props.ftoShortLabel + " personal calendar"}
          isOpen={this.state.showCalendarModal}
          onClose={(e) => this.closeCalendarModal(e)}
          size="lg"
          class="calendar-modal-container"
        >
          <div className="calendar-modal">
            <div className="form-group fto-container">
              <Input
                name="type"
                onChange={event =>
                  this.setSelectedFto(event.target.value, event)
                }
                type="select"
                value={this.state.selectedFtoGuid}
              >
                <option defaultValue>Select Fto</option>
                {this.getFtos && this.getFtos.map(fto => (
                  <option key={fto.guid} value={fto.guid}>{fto.getFullName()}</option>
                ))}
              </Input>
            </div>
            {this.state.selectedFtoGuid &&
            <DwCalendar
              events={this.eventsWithDate}
              canModify={false}
              defaultView='MONTH'
              defaultDate={this.state.currentDate.toDate()}
              showEditModal={(event) => this.onShowEventDetailsModal(event)}
              updateEventsForDateRange={(startDate, endDate) => this.onUpdateEventsForDateRange(startDate, endDate)}
            />
            }
          </div>
        </Modal>

        <Modal
          title={this.props.oitShortLabel + " personal calendar"}
          isOpen={this.state.showOitCalendarModal}
          onClose={(e) => this.closeOitCalendarModal(e)}
          size="lg"
          class="calendar-modal-container"
        >
          <div className="calendar-modal">
            <div className="form-group fto-container">
              <Input
                name="type"
                onChange={event =>
                  this.setSelectedCalendarOit(event.target.value, event)
                }
                type="select"
                value={this.state.selectedCalendarOitGuid}
              >
                <option defaultValue>Select {this.props.oitShortLabel}</option>
                {this.oitsInProgress && this.oitsInProgress.map(oit => (
                  <option key={oit.guid} value={oit.guid}>{oit.getFullName()}</option>
                ))}
              </Input>
            </div>
            {this.state.selectedCalendarOitGuid &&
            <DwCalendar
              events={this.eventsWithDate}
              canModify={false}
              defaultView='MONTH'
              defaultDate={this.state.currentDate.toDate()}
              showEditModal={(event) => this.onShowEventDetailsModal(event)}
              updateEventsForDateRange={(startDate, endDate) => this.onUpdateOitEventsForDateRange(startDate, endDate)}
            />
            }
          </div>
        </Modal>

        {this.state.selectedEvent &&
        <Modal
          isOpen={this.state.showEventDetailsModal}
          onClose={() => this.closeEventDetailsModal()}
          title="Event Details"
        >
          <div className="event-details-container">
            <div className="field">
              <div className="label">Date:</div>
                <div className="value">{moment(this.state.selectedEvent.start).format('YYYY-MM-DD')}</div>
              </div>

              <div className="field">
                <div className="label">Starts at:</div>
                <div className="value">{moment(this.state.selectedEvent.start).format('HH:mm')}</div>
              </div>

              <div className="field">
                <div className="label">Ends at:</div>
                <div className="value">{moment(this.state.selectedEvent.end).format('HH:mm')}</div>
              </div>

              <div className="field">
                <DisplayBoolean
                  label="All Day"
                  value={this.state.selectedEvent.allDay}
                />
              </div>

              <div className="field">
                <div className="label">Title:</div>
                <div className="value">{this.state.selectedEvent.title}</div>
              </div>

              <div className="field">
                <div className="label">Description:</div>
                <div className="value">{this.state.selectedEvent.desc}</div>
              </div>

              <div className="field">
                <div className="label">Type:</div>
                <div className="value">{this.getTypeLabel(this.state.selectedEvent.type)}</div>
              </div>
            </div>
          </Modal>
        }

        <Modal
          isOpen={this.state.showPbleFormDialog}
          onClose={() => this.setState({showPbleFormDialog: false})}
          title="Schedule PBLE"
        >
          {this.state.showPbleFormDialog && <div className="p-3">
            <PbleField
              onValueChange={(key, valueObject) => {
                this.handlePbleInput(key, valueObject)
              }}
              element={this.state.pbleField}
              name={this.state.pbleKey}
              value={{selected: null}}
              isEdit={true}
            />
            <div className="text-right">
              <LoadingButton text="Schedule form" isLoading={this.state.isFormSaving} primary={true}
                             onClick={() => this.submitPbleForm()}/>
            </div>
          </div>}
        </Modal>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    reports: state.trainingPhases.reports,
    forms: state.forms.list,
    activeFtos: state.ftos.list,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    canChangeFtoInSchedule: departmentSettingsSelectors.canChangeFtoInSchedule(state),
    users: state.users.usersByMaster,
    events: state.calendar.userList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope));
    },
    fetchReports: (trainingPhaseGuid) => {
      return dispatch(trainingPhasesReportsActionCreators.fetchReportsForTrainingPhase(trainingPhaseGuid))
    },
    createScheduledReports: (formData) => {
      return dispatch(trainingPhasesActionCreators.createScheduledReports(formData));
    },
    deleteScheduledReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteScheduledReport(reportGuid));
    },
    fetchFtos: () => {
      return dispatch(ftosActionCreators.fetchFtos());
    },
    fetchUsers: () => dispatch(usersActionCreators.fetchUsersByMaster()),
    fetchEventsForDateRange: (userId, startDate, endDate) => {
      return dispatch(calendarActionCreators.fetchEventsForDateRange(userId, startDate, endDate));
    },
    updateReportResponses: (formData, isAutoSave) => {
      return dispatch(trainingPhasesActionCreators.updateReportResponses(formData, isAutoSave));
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleReportsCalendar);
